import HandshqApp from 'handshq-app/handshq-app';
import i18n from 'shared/i18n';

HandshqApp.i18n = i18n;
